/* eslint-disable max-lines */
import Sidebar from '@/components/Sidebar/SidebarView.vue';
import Navbar from '@/components/HomeNavBar/HomeNavBar.vue';
import CreateFeed from '@/components/CreateFeed/CreateFeed.vue';
import { get_token, get_user_details } from "@/router";
import Swal from "sweetalert2";

export default {
  components: {
    Sidebar,
    Navbar,
    CreateFeed
  },
  data() {
    return ({
      editing: false,
      editingSegmentId: null,
      errors: {},
      isSubmitting: false,
      is_loading: false,
      user_details: {},
      selected_report: null,
      reports: [],
      tags: [],
      linkPreview: null,
      report_edit: [],
      edit_authors: [],
      edit_author_input: '',  // input for author name
      edit_author_link: '',
      temporaryPost: null,
      report_id: null,
      report_description: "",
      isLoading: false,
      token_exists: false,
      user_id: null,
      edit_report_link: '',
      report_data: {},
      edit_documents: [],
      audio_file_name: '',
      upload_media: null,
      fileError: '',
      audioError: '',
      editFileName: '',
      topics: [],
      boards: [],
      groups: [],
      board_name: '',
      group_name: '',
      group_description: '',
      is_public: true,
      boards_loading: false,
      groups_loading: false,
      active_portal_dashboard_tab: '#top_loans_info',
      categories: [],
      selected_tags: new Map(),
      reportsByCategories: [],
      subjects: [],
      selectedCategories: new Map(),
      primary_tag: null,
      showAllPrimary: false,
      showAllSecondary: false,
      primary_tags: new Map(),
      isCategoryModalOpenedFromFeed:false,
      comments_off: true,
      active_profile: null,
    });
  },

  props: ['topic_id'],

  mounted(){
    this.user_details = get_user_details();
    this.fetch_topics();
    this.fetch_reports_by_portal();
    this.fetch_grouped_tags();
    this.fetch_portal_boards();
    this.fetch_portal_groups();
  },
  computed: {
    can_manage_portal_creation_actions() {
      return ['admin', 'organization admin'].includes(this.user_details?.user_role);
    },
    is_publishing_portal() {
      const route_portal_type = this.$route.params.portal_type;
      const report_portal_type = this.reports?.[0]?.portal?.portal_type?.name ||
        this.reports?.[0]?.portal?.portal_type;

      return [route_portal_type, report_portal_type]
        .filter(Boolean)
        .some(type => String(type).toLowerCase() === 'publishing');
    },
    portal_dashboard_cards() {
      const cards = [
        { label: 'Reports', value: this.reports?.length || 0, icon: 'bi-newspaper', tone: 'primary', tab_target: '#top_loans_info' },
        { label: 'Boards', value: this.boards?.length || 0, icon: 'bi-kanban-fill', tone: 'info', tab_target: '#boards_info' },
        { label: 'Groups', value: this.groups?.length || 0, icon: 'bi-people-fill', tone: 'warning', tab_target: '#groups_info' },
      ];

      if (this.$route.params.portal_type === 'publishing') {
        cards.splice(1, 0, { label: 'Tags', value: this.tags?.length || 0, icon: 'bi-tags-fill', tone: 'secondary', tab_target: '#category_info' });
      } else {
        cards.splice(1, 0, { label: 'Segments', value: this.topics?.length || 0, icon: 'bi-diagram-3-fill', tone: 'success', tab_target: '#consolidation_loan_info' });
      }

      return cards;
    },
  },
  methods: {
    toggleSidebar() {
      this.$refs.sidebar.$el.classList.toggle("close");
    },
    getTextOnly(html) {
    return html.replace(/<[^>]*>/g, ''); // removes all HTML tags
  },
    getToken() {
      return get_token();
    },
    view_segment(topic) {
      this.$router.push({ name: 'view_report_topic', params: { topic_id: topic.id } });
    },
    view_tag_report(tag) {
      this.$router.push({ name: 'view_report_tag', params: { tag_id: tag.id } });
    },
    set_active_portal_dashboard_tab(tab_target) {
      this.active_portal_dashboard_tab = tab_target;
    },
    is_portal_dashboard_card_active(card) {
      return this.active_portal_dashboard_tab === card.tab_target;
    },
    handle_portal_dashboard_card_click(card) {
      this.active_portal_dashboard_tab = card.tab_target;
      const tab_trigger = document.querySelector(`[data-bs-target="${card.tab_target}"]`);
      if (tab_trigger) {
        tab_trigger.click();
      }
    },
    open_create_feed() {
      $('#feed_modal').modal('show');
    },
    open_create_board() {
      this.board_name = '';
      this.errors.board_name = null;
      $('#create_board_modal').modal('show');
    },
    open_create_group() {
      this.group_name = '';
      this.group_description = '';
      this.is_public = true;
      this.errors.group_name = null;
      $('#create_group_modal').modal('show');
    },
    run_active_portal_create_action() {
      switch (this.active_portal_dashboard_tab) {
        case '#top_loans_info':
          this.open_create_feed();
          break;
        case '#consolidation_loan_info':
          this.open_create_segment();
          break;
        case '#boards_info':
          this.open_create_board();
          break;
        case '#groups_info':
        case '#category_info':
          this.open_create_group();
          break;
        default:
          break;
      }
    },
    initDataTable(id) {
      const table = $(id);

      if (!table.length) return;
      if (!table.find('tbody tr').length) return;

      if ($.fn.DataTable.isDataTable(id)) {
        table.DataTable().destroy();
      }

      table.DataTable({
        paging: true,
        searching: true,
        ordering: true,
        info: true,
        lengthChange: true,
        pageLength: 10,
        language: {
          paginate: {
            previous: "Previous",
            next: "Next"
          },
          info: "Showing _START_ to _END_ of _TOTAL_ entries",
          infoEmpty: "No entries available"
        }
      });
    },
    destroyDataTable(id) {
      if ($.fn.DataTable.isDataTable(id)) {
        $(id).DataTable().destroy();
      }
    },
    init_portal_dashboard_tables() {
      this.$nextTick(() => {
        this.initDataTable('#report-table');
        this.initDataTable('#segments-table');
        this.initDataTable('#tags-table');
        this.initDataTable('#boards-table');
        this.initDataTable('#groups-table');
      });
    },
    handle_new_report() {
      this.fetch_reports_by_portal();
      this.set_active_portal_dashboard_tab('#top_loans_info');
    },
    validate_board_form() {
      this.errors.board_name = null;

      if (!this.board_name?.trim()) {
        this.errors.board_name = 'Board name is required.';
        return false;
      }

      return true;
    },
    create_portal_board() {
      if (!this.validate_board_form()) {
        return;
      }

      const portal_id = this.$route.params.portal_id;
      this.isSubmitting = true;

      $.ajax({
        url: `${process.env.VUE_APP_BACKEND_API_URL}/portal_management/create_board/`,
        method: 'POST',
        headers: {
          'Authorization': `Token ${this.getToken()}`,
          'Content-Type': 'application/json'
        },
        data: JSON.stringify({
          portal_id,
          name: this.board_name.trim(),
          base_url: '/view_board'
        }),
        success: (response) => {
          if (response.status === 'success') {
            $('#create_board_modal').modal('hide');
            this.board_name = '';
            this.fetch_portal_boards();
            this.set_active_portal_dashboard_tab('#boards_info');

            const board_id = response.data.id;
            const board_name = response.data.name;
            this.$router.push(`/view_board/${portal_id}/${board_id}/${board_name}`);
          }
        },
        error: (response) => {
          const response_data = response.responseJSON;
          this.errors.board_name = response_data?.message || 'Failed to create board.';
        },
        complete: () => {
          this.isSubmitting = false;
        }
      });
    },
    validate_group_form() {
      this.errors.group_name = null;

      if (!this.group_name?.trim()) {
        this.errors.group_name = 'Group name is required.';
        return false;
      }

      return true;
    },
    handle_create_portal_group_success(response) {
      if (response.status !== 'success') {
        return;
      }

      Swal.fire({
        icon: 'success',
        title: 'Group Created Successfully',
        showConfirmButton: false,
        timer: 1000,
        position: 'bottom-end',
        toast: true
      }).then(() => {
        $('#create_group_modal').modal('hide');
        this.group_name = '';
        this.group_description = '';
        this.is_public = true;
        this.fetch_portal_groups();
        this.set_active_portal_dashboard_tab('#groups_info');
      });
    },
    handle_create_portal_group_error(response) {
      const response_data = response.responseJSON;
      this.errors.group_name = response_data?.message || 'Failed to create group.';
    },
    create_portal_group() {
      if (!this.validate_group_form()) {
        return;
      }

      this.isSubmitting = true;
      const payload = {
        name: this.group_name.trim(),
        description: this.group_description.trim(),
        is_public: this.is_public,
        portal_id: this.$route.params.portal_id
      };

      $.ajax({
        type: 'POST',
        url: `${process.env.VUE_APP_BACKEND_API_URL}/group_management/create_group/`,
        contentType: 'application/json',
        headers: {
          'Authorization': `Token ${this.getToken()}`,
          'Content-Type': 'application/json'
        },
        data: JSON.stringify(payload),
        success: this.handle_create_portal_group_success,
        error: this.handle_create_portal_group_error,
        complete: () => {
          this.isSubmitting = false;
        }
      });
    },
    view_board(board) {
      this.$router.push({
        name: 'view_board',
        params: {
          portal_id: this.$route.params.portal_id,
          board_id: board.id,
          board_name: board.name
        }
      });
    },
    view_group(group) {
      this.$router.push({
        name: 'view_group',
        params: {
          portal_id: group.portal_id || this.$route.params.portal_id || 0,
          group_id: group.id,
          group_name: group.name,
          is_public: group.is_public
        }
      });
    },
    getFileIcon(fileUrl) {
      const iconMap = [
        { extensions: ['.pdf'], icon: 'https://cdn-icons-png.flaticon.com/128/337/337946.png' },
        { extensions: ['.doc', '.docx'], icon: 'https://cdn-icons-png.flaticon.com/128/337/337932.png' },
        { extensions: ['.xls', '.xlsx'], icon: 'https://cdn-icons-png.flaticon.com/128/337/337958.png' },
        { extensions: ['.ppt', '.pptx'], icon: 'https://cdn-icons-png.flaticon.com/128/337/337950.png' },
        { extensions: ['.html', '.htm'], icon: 'https://cdn-icons-png.flaticon.com/128/732/732212.png' },
        { extensions: ['.csv'], icon: 'https://cdn-icons-png.flaticon.com/128/8242/8242984.png' },
      ];

      for (const { extensions, icon } of iconMap) {
        if (extensions.some(ext => fileUrl.includes(ext))) {
          return icon;
        }
      }

      return 'https://cdn-icons-png.flaticon.com/128/337/337940.png'; // Default file icon
    },
    getFileName(fileUrl) {
      const decodedUrl = decodeURIComponent(fileUrl);
      const cleanUrl = decodedUrl.split('?')[0];
      return cleanUrl.substring(cleanUrl.lastIndexOf('/') + 1);
    },
    view_report(report) {
    this.selected_report = report;
    this.$nextTick(() => {
      $('#view_report_modal').modal('show');
    });
  },
  // Helper to strip HTML tags for descriptions

    open_create_segment() {
      this.editing = false;
      this.topic_name = '';
      this.editingSegmentId = null;
      this.errors = {};
      $('#segment_modal').modal('show');
    },
    open_edit_segment(segment) {
      this.editing = true;
      this.topic_name = segment.name;
      this.editingSegmentId = segment.id;
      this.errors = {};
      $('#segment_modal').modal('show');
    },
    submitSegment() {
      if (this.editing) {
        this.update_segment();
      } else {
        this.createSegment();
      }
    },
    delete_report(report_id) {
          Swal.fire({
            title: 'Are you sure?',
            text: 'You won\'t be able to revert this!',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes, delete it!',
            position: 'bottom-end',
            toast: true
          }).then((result) => {
            if (result.isConfirmed) {
              $.ajax({
                type: 'DELETE',
                url: `${process.env.VUE_APP_BACKEND_API_URL}/portal_management/delete_report_api/`,
                data: { report_id: report_id },
                headers: {
                  'Authorization': `Token ${this.getToken()}`,
                },
                success: () => {
                  Swal.fire({
                    icon: 'success',
                    title: 'Feed deleted',
                    showConfirmButton: false,
                    timer: 2000,
                    position: 'bottom-end',
                    toast: true
                  });
                  this.reports = this.reports.filter(r => r.id !== report_id);
                  $('#view_report_modal').modal('hide')

                },
                error: () => {
                  Swal.fire({
                    icon: 'error',
                    title: 'Error',
                    text: 'Failed to delete the feed. Please try again.',
                    position: 'bottom-end',
                    showConfirmButton: false,
                    timer: 3000,
                    toast: true
                  });
                }
              });
            }
          });
        },
        disable_report_method(report_id, currently_disabled) {
          const actionText = currently_disabled ? 'enable' : 'disable';
          const confirmButtonText = currently_disabled ? 'Yes, enable it!' : 'Yes, disable it!';
          const swalText = currently_disabled
            ? 'This will make the report visible again.'
            : 'You won\'t be able to view this report publicly after disabling it.';
    
          Swal.fire({
            title: `Are you sure you want to ${actionText} this report?`,
            text: swalText,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: confirmButtonText,
            position: 'bottom-end',
            toast: true
          }).then((result) => {
            if (result.isConfirmed) {
              $.ajax({
                type: 'POST',
                url: `${process.env.VUE_APP_BACKEND_API_URL}/portal_management/toggle_report_visibility/`,
                data: { report_id: report_id },
                headers: {
                  'Authorization': `Token ${this.getToken()}`,
                },
                success: (response) => {
                  const disabled = response.is_disabled;
                  this.selected_report.is_disabled=response.is_disabled;
    
                  Swal.fire({
                    icon: 'success',
                    title: disabled ? 'Feed disabled' : 'Feed enabled',
                    showConfirmButton: false,
                    timer: 2000,
                    position: 'bottom-end',
                    toast: true
                  });
                },
                error: () => {
                  Swal.fire({
                    icon: 'error',
                    title: 'Error',
                    text: 'Failed to change report visibility. Please try again.',
                    position: 'bottom-end',
                    showConfirmButton: false,
                    timer: 3000,
                    toast: true
                  });
                }
              });
            }
          });
        },
    open_edit_category_modal(report) {
      // Hide the edit report modal
      $('#edit_report_modal').modal('hide');

      // Populate primary tags
      if (report.primary_tag) {
        const categoryId = report.primary_tag.tag_category.id;
        this.primary_tags.set(categoryId, report.primary_tag);
      }
      $('#category_modal_edit').modal('show');
    },

    open_edit_author_modal() {
      $('#edit_report_modal').modal('hide');
      $('#author_modal_edit').modal('show');
    },
    add_author_method() {
      const name = this.edit_author_input.trim();
      const link = this.edit_author_link.trim() || '';

      if (!name) return;

      // Push to edit_authors array
      if (!this.edit_authors) this.edit_authors = [];
      this.edit_authors.push({
        author_name: name,
        author_link: link
      });

      // Clear inputs
      this.edit_author_input = '';
      this.edit_author_link = '';
    },

    remove_author_method(index) {
      this.edit_authors.splice(index, 1);
    },

    save_edit_author() {
      this.report_edit.authors = this.edit_authors;

      $('#author_modal_edit').modal('hide');
      $('#edit_report_modal').modal('show');
    },
    edit_report(report) {
      this.report_edit = report;
      this.edit_authors = report.authors;
      this.edit_author_input = this.edit_selected_author;
      const TextDescription = report.description;
      this.edit_report_link = report.report_link;
      this.report_id = report.id;
      this.edit_documents = report;
      this.selectedPortalId = report.portal?.id || '';
      this.selected_topic = report.topic?.id || '';
      this.selected_categories = report.tags?.map(tag => tag.tag_category) || [];
      this.comments_off = report.can_comment;

      // Initialize Maps
      this.primary_tags = new Map();
      this.selected_tags = new Map();

      // Set primary tag if exists
      if (report.primary_tag) {
        const catId = report.primary_tag.tag_category.id;
        this.primary_tags.set(catId, report.primary_tag);
        this.primary_tags = new Map(this.primary_tags); // reactive
        this.primary_tag = report.primary_tag; // <-- THIS is what was missing

      }

      // Prefill tags per category
      if (report.tags && Array.isArray(report.tags)) {
        report.tags.forEach(tag => {
          const catId = tag.tag_category.id;
          if (!this.selected_tags.has(catId)) this.selected_tags.set(catId, []);

          const catTags = this.selected_tags.get(catId);

          // If this tag is primary, add to front; else push normally
          if (report.primary_tag && tag.id === report.primary_tag.id) {
            catTags.unshift({
              id: tag.id,
              name: tag.name
            });
          } else {
            catTags.push({
              id: tag.id,
              name: tag.name
            });
          }

          this.selected_tags.set(catId, catTags);
        });
      }

      this.$nextTick(() => {
        const quillEditor = this.$refs.quillReportRef.getQuill();
        if (quillEditor) {
          quillEditor.clipboard.dangerouslyPasteHTML(TextDescription);

          quillEditor.root.addEventListener('paste', (e) => {
            const pastedText = e.clipboardData.getData('text');
            const match = pastedText.match(/(https?:\/\/[^\s]+)/g);
            if (match && match[0]) {
              report.report_link = match[0]; // update report object
              this.preview_link(report);
              this.edit_report_link = match[0];
            }
          });
        }
      });
      $('#edit_report_modal').modal('show');
    },
    handle_file_upload(event) {
      const file = event.target.files[0];
      if (file) {
        if (file.type.startsWith('audio/')) {
          this.fileError = 'Audio files are not allowed.';
          this.upload_media = null;
          this.editFileName = '';
          event.target.value = '';
        } else {
          this.editFileName = file.name;
          this.fileError = '';
          this.upload_media = file;
        }
      } else {
        this.editFileName = '';
        this.fileError = '';
        this.upload_media = null;
      }
    },
    preview_link(report) {

      $.ajax({
        url: `${process.env.VUE_APP_BACKEND_API_URL}/portal_management/fetch_url_meta/`,
        type: 'POST',
        data: { url: report.report_link },
        headers: { Authorization: `Token ${get_token()}` },
        success: (data) => { this.report_edit.linkPreview = data; },
      });
    },
      edit_report_data() {
        Swal.fire({
          title: 'Submitting...',
          text: 'Please wait while we process your request.',
          allowOutsideClick: false,
          didOpen: () => {
            Swal.showLoading();
          }
        });
        this.isSubmitting = true;
        const formData = new FormData();

        this.report_description = this.$refs.quillReportRef.getQuill().root.innerHTML.trim();
        formData.append('description', this.report_description);
        formData.append('can_comment', this.comments_off);
        formData.append('report_id', this.report_id);
        formData.append('authors', JSON.stringify(this.edit_authors))
        if (this.edit_report_link) {
          formData.append('report_link', this.edit_report_link);
        }
        if (this.upload_media) {
          formData.append('file', this.upload_media);
        }
        if (this.audio_file) {
          formData.append('file', this.audio_file, this.audio_file_name);
        }
        if (this.selected_topic) {
          formData.append('topic_id', this.selected_topic);
        }

        const tagIds = [];
        this.selected_tags.forEach(tagsArray => {
          tagsArray.forEach(tag => tagIds.push(tag.id));
        });
        tagIds.forEach(id => formData.append('tag_ids', id));

        // Only one primary tag
        if (this.primary_tag) {
          formData.append('primary_tag_id', this.primary_tag.id);
        };
        $.ajax({
          type: 'POST',
          url: `${process.env.VUE_APP_BACKEND_API_URL}/portal_management/update_report_api/`,
          data: formData,
          processData: false,
          contentType: false,
          headers: {
            'Authorization': `Token ${this.getToken()}`,
          },
          success: (response) => {
            if (response.status === 'success') {
              const updatedReport = response.updated_data;
              const author_name = updatedReport.authors[0]?.author_name;
              updatedReport.author_name = author_name;
              updatedReport.report_link = this.edit_report_link;
              updatedReport.total_comments = updatedReport.total_comments || 0;
  
              const reportIndex = this.reports.findIndex(
                (hub) => hub.id === updatedReport.id
              );
  
              if (reportIndex !== -1) {
                this.reports.splice(reportIndex, 1, updatedReport);
                updatedReport.linkPreview = this.report_edit.linkPreview;
              }
  
              Swal.fire({
                icon: 'success',
                title: response.message,
                showConfirmButton: false,
                timer: 1000,
                position: 'bottom-end',
                toast: true
              }).then(() => {
                $('#edit_report_modal').modal('hide');
                this.edit_name = '';
                this.edit_description = '';
                this.files_to_remove = [];
              });
            }
          },
          error: (response) => {
            Swal.close();
            const response_data = response.responseJSON;
            this.errors.edit_name = response_data.message;
          },
          complete: () => {
            this.isSubmitting = false;
          }
        });
      },
    fetch_grouped_tags() {
      this.isLoading = true;

      $.ajax({
        url: `${process.env.VUE_APP_BACKEND_API_URL}/portal_management/get_all_tags/`,
        method: 'GET',
        headers: {
          'Authorization': `Token ${this.getToken()}`,
          'Content-Type': 'application/json'
        },
        success: (response) => {
          if (response.status === "success") {
            const tag_list = response.data.tags;

        // Extract only tags
          this.tags = tag_list.map(tag => ({
            id: tag.id,
            name: tag.name
          }));
          this.init_portal_dashboard_tables();
          }
        },
        complete: () => {
          this.isLoading = false;
        }
      });
    },

    createSegment() {
          if (this.validateTopicForm()) {
            this.isSubmitting = true;

            const requestData = {
              topic_name: this.topic_name,
              portal_id: this.$route.params.portal_id
            };
            $.ajax({
              type: "POST",
              url: `${process.env.VUE_APP_BACKEND_API_URL}/portal_management/create_topic_api/`,
              contentType: "application/json",
              headers: {
                'Authorization': `Token ${this.getToken()}`,
                'Content-Type': 'application/json'
              },
              data: JSON.stringify(requestData),

              success: (response) => {
                const status = response.status;
                if (status === "success") {
                  Swal.fire({
                    icon: 'success',
                    title: 'Segment Created Successfully',
                    text: 'Your Segment has been created.',
                    showConfirmButton: false,
                    timer: 1000,
                    position: 'bottom-end',
                    toast: true
                  }).then(() => {
                    this.topics.unshift(response.topic);
                    this.topic_name='';
                    $('#segment_modal').modal('hide');
                  });
                } else if (status === "error") {
                  Swal.fire({
                    icon: 'error',
                    title: 'Creation Failed',
                    text: response.message || 'An error occurred. Please try again.',
                    confirmButtonText: 'Retry',
                    position: 'bottom-end',
                    showConfirmButton: false,
                    timer: 3000,
                    toast: true
                  });
                } else {
                  Swal.fire({
                    icon: 'error',
                    title: 'Unexpected Response',
                    text: 'The server returned an unexpected response.',
                    confirmButtonText: 'Okay',
                    position: 'bottom-end',
                    showConfirmButton: false,
                    timer: 3000,
                    toast: true
                  });
                }
              },
              error: (response) => {
                const response_data = response.responseJSON;
                if (response_data.status == "error") {
                  this.errors.topic_name = response_data.message
                }
              },
              complete: () => {
                this.isSubmitting = false;
              }
            });
          }
        },
        fetch_reports_by_portal() {
          this.is_loading = true;
          return new Promise(() => {
        $.ajax({
          url: `${process.env.VUE_APP_BACKEND_API_URL}/portal_management/get_reports_by_portal/`,
          method: 'POST',
          headers: {
            'Authorization': `Token ${this.getToken()}`,
            'Content-Type': 'application/json',
          },
          data: JSON.stringify({portal_id: this.$route.params.portal_id}),
          success: (data) => {
            const response = data
            if (response && response.status === 'success') {
              // backend may return an array directly or under report_data
              this.reports = response.report_data.results;
              this.is_loading = false;
              this.init_portal_dashboard_tables();
            } else {
              this.destroyDataTable('#report-table');
              this.reports = [];
            }
          },
          error: () => {
            this.destroyDataTable('#report-table');
            this.reports = [];
          },
          complete: () => {
            this.is_loading = false;
          },
        });
      });
        },

        update_segment() {
          // Your API call for update
          $.ajax({
            type: 'POST',
            url: `${process.env.VUE_APP_BACKEND_API_URL}/portal_management/update_topic_api/`,
            data: {
              topic_id: this.editingSegmentId,
              topic_name: this.topic_name
            },
            headers: {
              'Authorization': `Token ${this.getToken()}`,
            },
            success: (response) => {
              if (response.status === 'success') {
              const updated_segment = this.topics.find(p => p.id === this.editingSegmentId);
                if (updated_segment) {
                  updated_segment.name = this.topic_name;
                }
                $('#segment_modal').modal('hide');
              }
            },
            error: (xhr) => {
              this.errors = xhr.responseJSON?.errors || {};
            }
          });
        },
        fetch_portal_boards() {
          const portal_id = this.$route.params.portal_id;
          this.boards_loading = true;

          $.ajax({
            url: `${process.env.VUE_APP_BACKEND_API_URL}/portal_management/get_portal_boards/`,
            method: 'POST',
            headers: {
              'Authorization': `Token ${this.getToken()}`,
              'Content-Type': 'application/json'
            },
            data: JSON.stringify({ portal_id }),
            success: (response) => {
              if (response.status === 'success') {
                this.boards = Array.isArray(response.data) ? response.data : [];
                this.init_portal_dashboard_tables();
              } else {
                this.boards = [];
              }
            },
            error: () => {
              this.boards = [];
            },
            complete: () => {
              this.boards_loading = false;
            }
          });
        },
        fetch_portal_groups() {
          const portal_id = this.$route.params.portal_id;
          this.groups_loading = true;

          $.ajax({
            url: `${process.env.VUE_APP_BACKEND_API_URL}/group_management/portal_group/`,
            method: 'GET',
            headers: {
              'Authorization': `Token ${this.getToken()}`,
              'Content-Type': 'application/json'
            },
            data: { portal_id },
            success: (response) => {
              const groups = Array.isArray(response.groups) ? response.groups : [];
              this.groups = groups.sort((a, b) => b.id - a.id);
              this.init_portal_dashboard_tables();
            },
            error: () => {
              this.groups = [];
            },
            complete: () => {
              this.groups_loading = false;
            }
          });
        },

    validateTopicForm() {
      this.errors = {};
      let isValid = true;
      if (!this.topic_name.trim()) {
        this.errors.topic_name = 'Segment name is required.';
        isValid = false;
      }
      return isValid;
    },

    fetch_topics() {
      const portal_id = this.$route.params.portal_id;
      this.isLoading = true;
      $.ajax({
        url: `${process.env.VUE_APP_BACKEND_API_URL}/portal_management/get_all_topics_api`,
        method: 'GET',
        headers: {
          'Authorization': `Token ${this.getToken()}`,
          'Content-Type': 'application/json'
        },
        data: {portal_id: portal_id},
        success: (response) => {
          var status = response.status
          if (status == "success") {
            this.topics = response.topics
            this.init_portal_dashboard_tables();
          }
        },

        complete: () => {
          this.isLoading = false;
        }
      });
    },
      delete_segment(segment_id) {
            Swal.fire({
              title: 'Are you sure?',
              text: 'You won\'t be able to revert this!',
              icon: 'warning',
              showCancelButton: true,
              confirmButtonColor: '#3085d6',
              cancelButtonColor: '#d33',
              confirmButtonText: 'Yes, delete it!',
              position: 'bottom-end',
              toast: true
            }).then((result) => {
              if (result.isConfirmed) {
                $.ajax({
                  type: 'DELETE',
                  url: `${process.env.VUE_APP_BACKEND_API_URL}/portal_management/delete_topic_api/`,
                  data: { topic_id: segment_id },
                  headers: {
                    'Authorization': `Token ${this.getToken()}`,
                  },
                  success: (response) => {
                    const status = response.status;
                    if (status === "success") {
                      this.topics = this.topics.filter(topic => topic.id !== segment_id);

                      Swal.fire({
                        title: 'Deleted!',
                        text: 'The feed has been deleted.',
                        icon: 'success',
                        showConfirmButton: false,
                        timer: 1000,
                        position: 'bottom-end',
                        toast: true
                      })
                    }
                  },
                  error: () => {
                    Swal.fire({
                      icon: 'error',
                      title: 'Error',
                      text: 'Failed to delete the feed. Please try again.',
                      position: 'bottom-end',
                      showConfirmButton: false,
                      timer: 3000,
                      toast: true
                    });
                  }
                });
              }
            });
          },
    }
  };
